import React from 'react';
import { createPortal } from 'react-dom';
import { ITableLoading } from '../../types/ITableLoading';
import { Orbit } from '@uiball/loaders';
import './tableLoading.scss';

const TableLoading: React.FC<ITableLoading> = ({ tableElement }) => {
  if (tableElement && tableElement.current)
    return createPortal(
      <div className={'k-loading-mask table-loader'}>
        <Orbit size={25} speed={1.5} color='black' />
      </div>,
      tableElement.current.element
    );
  // return ReactDOM.createPortal(<ComponentLoader background />, tableElement.current.element);

  return null;
};

export default TableLoading;
